import 'Variables';
import { gtm } from 'Partials/gtm';
import { randomAvatarOnError } from 'Library/helpers';
import { ww } from 'bobjoll/ts/library/dom';

ww.randomAvatarOnError = randomAvatarOnError;
ww.gtm = gtm;